import { Routes } from '@angular/router';
import { authCanActivateChildGuard } from './services/auth';

export const routes: Routes = [
  { path: "", redirectTo: "login", pathMatch: "full" },
  { path: "login", loadComponent: () => import("./pages/login").then(m => m.Login) },
  { path: "home", loadChildren: () => import("./pages/home/home-module").then(m => m.HomeModule), canActivate: [authCanActivateChildGuard] },
  { path: "**", redirectTo: "login", pathMatch: "full" }
];
